import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tags-input"
export default class extends Controller {
  static targets = ["input", "container", "hiddenInput", "tag"]
  static values = {
    maxItems: {
      type: Number,
      default: 0
    },
    selectedTags: {
      type: Array,
      default: []
    }
  }

  connect() {
    const hasSelectedTags = this.selectedTagsValue.filter(tag => tag !== "").length > 0
    if (hasSelectedTags) {
      this.selectedTagsValue.forEach(tag => {
        this.addTagElement(tag)
      })
      this.updateHiddenInput()
    }
  }

  keydownHandler(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.addTag()
    }

    if (event.key === "Backspace") {
      if (this.inputTarget.value === "") {
        event.preventDefault()
        this.editLastTag()
      }
    }
  }

  addTag() {
    const childrenCount = this.containerTarget.children.length - 1
    if (this.maxItemsValue && childrenCount >= this.maxItemsValue) {
      return
    }

    const value = this.inputTarget.value.trim()

    if (!value) return

    this.addTagElement(value)

    this.inputTarget.value = ""

    this.updateHiddenInput()
    this.dispatchTagAddedEvent()
  }

  addTagElement(value) {
    const tagEl = this.createTagElement(value)
    this.containerTarget.insertBefore(tagEl, this.inputTarget)
  }

  createTagElement(value) {
    const tag = document.createElement("span")
    tag.className = "flex items-center gap-4 m-0 pl-5 py-3 bg-seasalt-300 text-darkblue leading-23 wrap-anywhere rounded-5 overflow-hidden"
    tag.textContent = value
    tag.dataset.tag = value
    tag.dataset.tagsInputTarget = "tag"

    const xmark = document.createElement("i")
    xmark.className = "icon-xmark p-4 text-seasalt-500 text-xs cursor-pointer"
    xmark.addEventListener("click", () => {
      this.containerTarget.removeChild(tag)
      this.updateHiddenInput()
      this.dispatchTagDeletedEvent()
    })
    tag.appendChild(xmark)
    return tag
  }

  editLastTag() {
    const tags = this.tagTargets
    if (tags.length > 0) {
      const lastTag = tags[tags.length - 1]
      this.inputTarget.value = lastTag.dataset.tag
      this.containerTarget.removeChild(lastTag)
      this.updateHiddenInput()
      this.dispatchTagDeletedEvent()
    }
  }

  updateHiddenInput() {
    if (!this.hasHiddenInputTarget)
      return

    const tags = []
    this.tagTargets.forEach(tagEl => {
      tags.push(tagEl.dataset.tag)
    })

    if (tags.length === 0) {
      this.hiddenInputTarget.value = ""
      return
    }

    this.hiddenInputTarget.value = JSON.stringify(tags)
  }

  dispatchTagAddedEvent() {
    const event = new CustomEvent("tags-input:added", { bubbles: true })
    this.containerTarget.dispatchEvent(event)
  }

  dispatchTagDeletedEvent() {
    const event = new CustomEvent("tags-input:deleted", { bubbles: true })
    this.containerTarget.dispatchEvent(event)
  }
}
